// Options and defaults for Administration > Organisation > Settings.
// No settings API exists yet, so these are sample values.

// Each date format is shown with the same sample date so the choices are
// easy to compare.
const dateFormat = (value, example) => ({
  value,
  label: value + " ( " + example + " )",
});

export const DATE_FORMAT_OPTIONS = [
  dateFormat("DD MMM YYYY", "28 Sep 2026"),
  dateFormat("DD/MM/YYYY", "28/09/2026"),
  dateFormat("MM/DD/YYYY", "09/28/2026"),
  dateFormat("YYYY-MM-DD", "2026-09-28"),
  dateFormat("DD-MM-YYYY", "28-09-2026"),
];

export const TIME_ZONE_OPTIONS = [
  { value: "Asia/Kolkata", label: "(UTC+05:30) India Standard Time (IST)" },
  { value: "Asia/Dubai", label: "(UTC+04:00) Gulf Standard Time (GST)" },
  { value: "Asia/Singapore", label: "(UTC+08:00) Singapore Time (SGT)" },
  { value: "Europe/London", label: "(UTC+00:00) Greenwich Mean Time (GMT)" },
  { value: "America/New_York", label: "(UTC-05:00) Eastern Time (ET)" },
  { value: "UTC", label: "(UTC+00:00) Coordinated Universal Time (UTC)" },
];

export const LANGUAGE_OPTIONS = [{ value: "en", label: "English" }];

// Default company scope offered for manual actions and reprocessing.
export const SCOPE_OPTIONS = [
  {
    value: "current",
    title: "Current Tenant",
    text: "Apply to the company you are currently working in.",
  },
  {
    value: "all",
    title: "All Applicable Tenants",
    text: "Apply to all applicable companies in the organisation.",
    // Not available yet: shown disabled with a "Coming soon" tag.
    comingSoon: true,
  },
];

// Upper bound for the minute settings: one day.
export const MINUTES_LIMIT = 1440;

export const buildOrganisationSettingsDefaults = () => ({
  dateFormat: "DD MMM YYYY",
  timeZone: "Asia/Kolkata",
  language: "en",
  // Whole minutes, kept as text while being typed.
  minimumPunchDifference: "1",
  minimumInOutPunchDifference: "1",
  attendanceProcessingDelay: "0",
  manualProcessingScope: "current",
  reprocessingScope: "current",
});

const REQUIRED = {
  dateFormat: [DATE_FORMAT_OPTIONS, "Select a date format."],
  timeZone: [TIME_ZONE_OPTIONS, "Select a time zone."],
  language: [LANGUAGE_OPTIONS, "Select a default language."],
  manualProcessingScope: [SCOPE_OPTIONS, "Select a manual processing scope."],
  reprocessingScope: [SCOPE_OPTIONS, "Select a reprocessing scope."],
};

const MINUTE_FIELDS = {
  minimumPunchDifference: "minimum same-type punch difference",
  minimumInOutPunchDifference: "minimum IN-OUT punch difference",
  attendanceProcessingDelay: "attendance processing delay",
};

export const validateOrganisationSettings = (form) => {
  const errors = {};
  Object.entries(REQUIRED).forEach(([key, [options, message]]) => {
    if (!options.some((option) => option.value === form[key])) {
      errors[key] = message;
    }
  });
  Object.entries(MINUTE_FIELDS).forEach(([key, name]) => {
    const text = String(form[key] ?? "").trim();
    if (!/^[0-9]+$/.test(text)) {
      errors[key] = "Enter the " + name + " in whole minutes.";
    } else if (Number(text) > MINUTES_LIMIT) {
      errors[key] = "Enter " + MINUTES_LIMIT + " minutes or less.";
    }
  });
  return errors;
};
